import ClientModel from '@spike/client-model';
import PetModel from '@spike/pet-model';
import { OverFullWindow } from 'components/UI';
import { useWaitlistPanel } from 'components/Waitlist/WaitlistPanel/WaitlistPanelContext';
import Client from 'pages/Client';
import { FunctionComponent, useEffect } from 'react';
import { createPortal } from 'react-dom';

interface WaitlistClientWindowProps {
    /** Client a pet is added to; a new client when undefined. */
    clientId?: number;
    /** Opens the client profile as is, without starting to add a pet. */
    viewOnly?: boolean;
    onClientSaved?: (client: ClientModel) => void;
    onPetSaved?: (pet: PetModel) => void;
    onClose: () => void;
}

// The client page Add Appointment opens for "Add New Client" and "Add Pet". The waitlist panel is
// hidden meanwhile (not closed, so the waitlist being added is kept).
export const WaitlistClientWindow: FunctionComponent<WaitlistClientWindowProps> = ({
    clientId,
    viewOnly,
    onClientSaved,
    onPetSaved,
    onClose
}) => {
    const { setHidden } = useWaitlistPanel();

    useEffect(() => {
        setHidden(true);

        return () => setHidden(false);
    }, []);

    return createPortal(
        <OverFullWindow onClose={onClose}>
            <Client
                hideHeader={true}
                clientId={clientId}
                isNewBooking={clientId !== undefined && !viewOnly}
                onClose={onClose}
                onClientSaved={onClientSaved}
                onPetSaved={onPetSaved}
                onDelete={onClose}
            />
        </OverFullWindow>,
        document.body
    );
};

export default WaitlistClientWindow;
